module.exports = __webpack_public_path__ + "img/skin-logo.5c6f7795.jpg";